var React = require('react');

function ShapesRewindInline (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"5.32 248.78 99.14 5.91 173.66 174.26 5.32 248.78","fill":"none","stroke":"#f0f","strokeMiterlimit":"10","key":0}),React.createElement("polygon",{"points":"128.58 296.45 222.4 53.58 296.93 221.92 128.58 296.45","fill":"none","stroke":"#f0f","strokeMiterlimit":"10","key":1})]);
}

ShapesRewindInline.defaultProps = {"viewBox":"0 0 303 303"};

module.exports = ShapesRewindInline;

ShapesRewindInline.default = ShapesRewindInline;
